import { render, staticRenderFns } from "./MilestoneTaskBoardDetailsViewDev.vue?vue&type=template&id=2d3f2783&"
import script from "./MilestoneTaskBoardDetailsViewDev.vue?vue&type=script&lang=js&"
export * from "./MilestoneTaskBoardDetailsViewDev.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneTaskBoardDetailsViewDev.vue?vue&type=style&index=0&id=2d3f2783&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports